import { LoyaltyPointConversionRateEndpoint } from '../common/endpoints';
import { LoyaltyPointConversionRate, ServerResponse } from '../common/types';
import { getRequest, postRequest } from './requests';


export const getById = async (id: number) => {
    const result: ServerResponse<LoyaltyPointConversionRate> = await getRequest(
        `${LoyaltyPointConversionRateEndpoint}/${id}`,
    );
    return result;
}

export const list = async () => {
    const result: ServerResponse<LoyaltyPointConversionRate[]> = await getRequest(
        `${LoyaltyPointConversionRateEndpoint}?latestOnly=false`,
    );
    return result;
}

export const getLateset = async () => {
    const result: ServerResponse<LoyaltyPointConversionRate> = await getRequest(
        `${LoyaltyPointConversionRateEndpoint}?latestOnly=true`,
    );
    return result;
}

export const create = async (pointsToOneDollar: number) => {
    const result: ServerResponse<LoyaltyPointConversionRate> = await postRequest(
        `${LoyaltyPointConversionRateEndpoint}`, { pointsToOneDollar }
    );
    return result;
}